<template src="../../templates/form/bull-form.pug" lang="pug" />

<script>
import Modal from "@/views/form/Modal.vue"
import {mapActions, mapGetters, mapMutations} from "vuex"
import {format} from "date-fns"
import {maxLength, maxValue, minLength, required} from "vuelidate/lib/validators"

export default {
    name: "BullForm",
    components: {
        Modal,
    },
    props: ['bullToUpdate'],
    data() {
        return {
            bull: {}
        }
    },
    computed: {
        ...mapGetters([
                'selectedFarm',
                'bulls',
                'isBuckleNumberAlreadyGiven'
        ]),
        _birthday: {
            get() {
                return format(new Date(this.bull.birthday * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.bull.birthday = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        isFormValid() {
            return this.bull.id != null
                    ? !this.$v.bull.birthday.$invalid &&
                    (this.bull.buckleNumber !== this.bullToUpdate.buckleNumber ||
                            this.bull.bullRating.fertility !== this.bullToUpdate.bullRating.fertility ||
                            this.bull.bullRating.milkProduction !== this.bullToUpdate.bullRating.milkProduction ||
                            this.bull.bullRating.udderHealth !== this.bullToUpdate.bullRating.udderHealth ||
                            this.bull.bullRating.sicknessProprensity !== this.bullToUpdate.bullRating.sicknessProprensity)
                    : !this.$v.bull.birthday.$invalid && !this.$v.bull.buckleNumber.$invalid
        }
    },
    created() {
        this.bull = {
            id: this.bullToUpdate.id,
            birthday: this.bullToUpdate.birthday,
            buckleNumber: this.bullToUpdate.buckleNumber,
            building:
                    this.bullToUpdate.building === null
                            ? this.selectedFarm.buildings[0].id
                            : this.bullToUpdate.building,
            type: this.bullToUpdate.type,
            bullRating: {
                id: this.bullToUpdate.bullRating.id,
                fertility: this.bullToUpdate.bullRating.fertility,
                milkProduction: this.bullToUpdate.bullRating.milkProduction,
                udderHealth: this.bullToUpdate.bullRating.udderHealth,
                sicknessProprensity: this.bullToUpdate.bullRating.sicknessProprensity
            },
            isBought: this.bullToUpdate.isBought
        }
    },
    validations: {
        bull: {
            birthday: {
                maxValue: maxValue(Math.trunc(Date.now() / 1000) + 24 * 60 * 60)
            },
            buckleNumber: {
                required,
                isUnique(value) {
                    if (value === '') {
                        return true
                    }
                    return !this.isBuckleNumberAlreadyGiven(value)
                },
                minLength: minLength(1),
                maxLength: maxLength(15)
            }
        }
    },
    methods: {
        ...mapActions(['createBull', 'editBull']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            if (this.isFormValid) {
                if (this.bull.id !== null) {
                    this.editBull(this.bull)
                } else {
                    this.createBull(this.bull)
                }
                this.close()
            }
        }
    }
}
</script>

<style lang="sass">
@import '../../sass/mixin/color'
@import '../../sass/mixin/flex'

#bull-modal
    .modal-container
        .modal-header
            background-color: $dd-light-orange
            color: white
        .modal-body
            form
                input, input:focus, input:valid, .multiselect
                    border-left: 8px solid $dd-light-orange
                .select
                    @include flex-center
                    .form-select
                        width: 100%
                        height: 40px
                        background: url('/img/br_down.png') 96% no-repeat #fff
                        border-left: 8px solid $dd-light-orange
                        border-bottom: none
                        border-right: none
                        border-top: transparent
                        padding: 0.25em
                        font-size: 16px
                        font-weight: bold
                        -webkit-appearance: none
                        -moz-appearance: none
                        appearance: none
                .rating-material
                    @include flexbox
                    @include flex-direction(row)
                    @include justify-content(space-around)
                    label
                        color: $grey2
                        font-size: 1em
                        font-weight: 700
                        width: 35px
                        height: 35px
                        border-radius: 50%
                        border-style: solid
                        border-color: $dd-light-orange
                        border-width: 1px
                        display: grid
                        place-items: center
                        background: white
                        transition: 0.2s ease-in-out
                        cursor: pointer
                        &:hover
                            background: $dd-light-orange
                            color: white
                    input
                        position: absolute
                        width: 35px
                        height: 35px
                        border-radius: 50%
                        opacity: 0
                        background-color: $grey2
                        &:checked + label
                            background: $dd-light-orange
                            color: white
                        &:hover
                            background: $grey2
                            color: $grey5



</style>